import { createSelector } from 'reselect';
import _ from 'lodash';

const getReportingDocumentState = state => _.get(state, 'reportingDocuments');

export const fetchingDocumentIdSelector = createSelector(
    getReportingDocumentState,
    state => state.isFetching && state.documentId || null
);
